import { Card, CardBody, Container, Row } from "reactstrap"
import { Breadcrumbs } from "../../../../AbstractElements"
import { BillingDetails, CheckOutTitle, ECommerce } from "../../../../Constants/Constants"
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader"
import CheckoutTableData from "./CheckoutTableData";
import ProductCheckout from "./ProductCheckout";

const CheckOutContainer = () => {
  return (
    <>
    <Breadcrumbs mainTitle={CheckOutTitle} parent={ECommerce} />
    <Container fluid>
      <Card className="checkout">
        <CommonCardHeader title={BillingDetails} />
        <CardBody>
          <Row>
            <CheckoutTableData />
            <ProductCheckout />
          </Row>
        </CardBody>
      </Card>
    </Container>
  </>
  )
}

export default CheckOutContainer